import { IAtHeaderProps } from './at-header.types';

export const atHeaderMockData: IAtHeaderProps = {
  children: <span>Schumacher homes</span>,
  element: 'h3',
};
